var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptCompletion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-246560e2-7110-436b-aa8e-00391a2b0955",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m28.067,38.723v-17.458c0-1.307.765-2.071,2.084-2.071h3.501c.839,0,1.368.493,1.368,1.319s-.529,1.332-1.368,1.332h-2.133v16.312h2.133c.839,0,1.368.493,1.368,1.319s-.529,1.332-1.368,1.332h-3.501c-1.319,0-2.084-.777-2.084-2.084Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.735,35.147c0-1.11.876-1.985,1.985-1.985,1.098,0,1.985.875,1.985,1.985,0,1.097-.888,1.985-1.985,1.985-1.109,0-1.985-.888-1.985-1.985Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.755,35.147c0-1.11.876-1.985,1.985-1.985,1.098,0,1.985.875,1.985,1.985,0,1.097-.888,1.985-1.985,1.985-1.109,0-1.985-.888-1.985-1.985Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.774,35.147c0-1.11.876-1.985,1.985-1.985,1.098,0,1.985.875,1.985,1.985,0,1.097-.888,1.985-1.985,1.985-1.109,0-1.985-.888-1.985-1.985Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.335,40.807c-.826,0-1.369-.506-1.369-1.332s.53-1.319,1.369-1.319h2.133v-16.312h-2.133c-.826,0-1.369-.505-1.369-1.332s.53-1.319,1.369-1.319h3.514c1.307,0,2.084.765,2.084,2.071v17.458c0,1.307-.777,2.084-2.084,2.084h-3.514Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptCompletion);
export default __webpack_public_path__ + "static/media/PromptCompletion.02e5a55da7bf0257e4eff112af36b339.svg";
export { ForwardRef as ReactComponent };